import Konva from 'konva'

export default {
  data () {
    return {
      canDelete: false,
      select: false,
      focusedElement: null,
      deletableChildren: [],
      selectedDeletableChildren: [],
      deleteAll: false
    }
  },
  methods: {
    enableSelection () {
      this.viewMenu = false
      this.select = true
      this.draw = false
      this.focusedElement = null
      this.clearSelection()
    },
    enableDraw () {
      if (this.draw) { return }
      this.select = false
      this.canDelete = false
      this.draw = true
      this.focusedElement = null
      this.clearSelection()
    },

    deleteMapping () {
      let name = this.highlightShape && this.highlightShape.name()
      let highlightShape = (name === 'group_holder') ? this.highlightShape.parent : this.highlightShape

      if (name === 'group' || name === 'group_holder') {
        this.deletableChildren = highlightShape.children.filter((child) => { return child.name() !== 'group_holder' })
        this.$refs.deleteGroupModal.show()
      } else {
        this.removeShape()
      }
    },

    selectAllDeletableChildren () {
      if (this.deleteAll) {
        this.selectedDeletableChildren = this.deletableChildren.map((child) => {
          return child.attrs.uniq_id
        })
      } else {
        this.selectedDeletableChildren = []
      }
    },

    deleteGroup () {
      this.drawLayer.find('Transformer').destroy()
      let name = this.highlightShape && this.highlightShape.name()
      let highlightShape = (name === 'group_holder') ? this.highlightShape.parent : this.highlightShape
      let groupChildren = highlightShape.children.slice()
      groupChildren.forEach((child) => {
        if (child.name() !== 'group_holder') {
          let uniqId = child.attrs.uniq_id
          if (this.selectedDeletableChildren.indexOf(uniqId) === -1) {
            let updatedChild = this.updateChildAttrs(child, 0, 0)
            this.drawLayer.add(updatedChild)
          }
        }
      })
      this.highlightShape.remove()
      this.canDelete = false
      this.clearSelection()
      this.drawLayer.draw()
      this.updateMappingData()
      this.pushToHistory()
    },

    updateChildAttrs (node, parentX, parentY) {
      let newShape
      let updatedAttrs = node.attrs
      if (node.name() !== 'group_holder') {
        let updatedPath = node.attrs.path.split('.')
        updatedPath.splice(1, 1)
        updatedAttrs.path = updatedPath.join('.')
        updatedAttrs.x = node.attrs.x_pos - parentX
        updatedAttrs.y = node.attrs.y_pos - parentY
      }
      if (node.nodeType === 'Group') {
        newShape = new Konva.Group({})
        newShape.setAttrs(Object.assign({}, updatedAttrs))
        let updatedChildren = node.children.map((child) => {
          return this.updateChildAttrs(child, newShape.attrs.x_pos, newShape.attrs.y_pos)
        })
        updatedChildren.forEach((child) => {
          newShape.add(child)
        })
      } else {
        newShape = new Konva.Rect({})
        newShape.setAttrs(Object.assign({}, updatedAttrs))
      }
      return newShape
    },

    cancelDeleteGroup () {
      this.deletableChildren = []
      this.selectedDeletableChildren = []
    },

    removeShape () {
      this.drawLayer.find('Transformer').destroy()

      if (this.highlightShape && this.highlightShape.name() === 'group_holder') {
        this.highlightShape.parent.remove()
      } else {
        this.highlightShape.remove()
      }
      this.canDelete = false
      this.clearSelection()
      this.drawLayer.draw()

      this.updateMappingData()
      this.pushToHistory()
    },

    clearSelection () {
      let vm = this
      var selected = this.stage.find('Rect').filter(function (shape) {
        return shape.attrs.selected === true
      })
      selected.forEach(function (shape) {
        shape.setAttrs({
          selected: false,
          stroke: vm.theme[vm.selectedTheme].strokeColor,
          shadowColor: false,
          shadowBlur: false,
          dash: false
        })
      })
      this.stage.draw()
    },

    highlightSelection: function (shape) {
      if (shape.nodeType === 'Group') {
        shape = shape.findOne('.group_holder')
      }
      shape.setAttrs({
        selected: true,
        shadowColor: this.theme[this.selectedTheme].shadowColor,
        shadowBlur: this.theme[this.selectedTheme].shadowBlur,
        dash: [5, 5]
      })
      this.drawLayer.draw()
    },

    repositionGroup: function (group, position) {
      group.setAttrs({
        x: position.x,
        y: position.y,
        x_pos: position.x,
        y_pos: position.y
      })

      let shapes = group.find('.crop_rect')

      shapes.forEach((shape) => {
        shape.setAttrs({
          x_pos: group.attrs.x + shape.attrs.x,
          y_pos: group.attrs.y + shape.attrs.y
        })
      })
    },

    updateGroupShapes: function (group) {
      let shapes = group.find('.crop_rect')

      shapes.forEach((shape) => {
        shape.setAttrs({
          x_pos: group.attrs.x + shape.attrs.x,
          y_pos: group.attrs.y + shape.attrs.y
        })
      })
    },

    createDupGroup: function (group, position) {
      let parent = this.drawLayer

      group.setAttrs({
        x: position.x,
        y: position.y,
        x_pos: position.x,
        y_pos: position.y,
        path: parent.attrs.path + '.' + this.pathCount
      })

      this.pathCount++

      let shapes = group.find('.crop_rect')

      shapes.forEach((shape) => {
        shape.setAttrs({
          x_pos: group.attrs.x + shape.attrs.x,
          y_pos: group.attrs.y + shape.attrs.y,
          path: group.attrs.path + '.' + this.pathCount
        })

        this.pathCount++
      })

      this.highlightShape = group.findOne('.group_holder')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/KonvaEditor.js